<footer class="footer">
  <div class="footer-container content-container">
    <div class="first-block">
      <div class="logo">
        <svg [icon]="icons.Logo" class="svg24 logo-icon"/>
        <div class="title">
          <h1>{{ 'LAYOUT.PORTALNAME' | translate }}</h1>
          <p>{{ 'LAYOUT.GOVERMENT' | translate }}</p>
        </div>
      </div>
      <div class="links" *ngLet="langChange$ | async">
        <span class="caption-4 technical_support_text mb8">{{'FOOTER.TECHNICAL_SUPPORT' | translate}}:
          <a href="mailto:opendata@mos.ru" class="caption-3 dark footer-link" (click)="statEvent()">opendata&#64;mos.ru</a>
        </span>
        <a [routerLink]="['/terms']" class="caption-3 dark mb8 footer-link">{{'FOOTER.TERMS_CONDITIONS' | translate}}</a>
        <a *ngIf="isRuLocale"  [routerLink]="['/documents']" class="caption-3 dark footer-link">{{'FOOTER.DOCUMENTATION' | translate}}</a>
      </div>
    </div>

    <div class="last-block" >
      <div class="icon-block" social-share>

      </div>
      <span class="footer-text caption-4 mb8">{{'FOOTER.LICENCE' | translate}} <a href="https://creativecommons.org/licenses/by/4.0/deed.ru" target="_blank" class="caption-3 footer-link" rel="nofollow">Creative Commons Attribution 4.0</a>. {{'FOOTER.LICENCE_LAST' | translate}}.</span>
      <span class="footer-text caption-4 mb8">{{'FOOTER.REGARDING' | translate}} <a href="https://data.mos.ru" target="_blank" class="caption-3 footer-link" rel="nofollow">https://data.mos.ru</a>, {{'FOOTER.MATERIAL_AVAILABLE' | translate}} <a href="https://data.gov.ru/normative_base" target="_blank" class="caption-3 footer-link" rel="nofollow">https://data.gov.ru/normative_base</a>.</span>
      <span class="footer-text caption-4 mb8"><a class="caption-3 dark footer-link" target="_blank"  href="https://www.mos.ru/legal/rules/">{{'FOOTER.AGREEMENT' | translate}}</a></span>
      <span class="footer-text caption-4"><a class="caption-3 dark footer-link" target="_blank"  href="https://www.mos.ru/dit/documents/informatcionnaia-bezopasnost/view/274898220/">{{'FOOTER.PERSONAL_DATA_POLITICS' | translate}}</a></span>
    </div>
  </div>
</footer>
